<div role="dialog" aria-labelledby="webhookPayload">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="webhookPayload" class="modal-title">Webhook Payload</h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="onClose()"
        ></button>
      </div>
      <div class="modal-body">
        <pre>{{ webhook | json }}</pre>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [mat-dialog-close]="true">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>
